import React, { FC, KeyboardEvent } from 'react';
import { Box, Button, Autocomplete, TextField } from '@mui/material';
import { FilterInputProps } from './types';
import { GooglePlacesAutocomplete } from '../../Components/CustomUIElements/GooglePlacesAutocomplete';
import { theme } from '../../../ThemeContext/ThemeObject';

const FilterInput: FC<FilterInputProps> = ({
  options,
  value,
  placeholder,
  buttonText,
  onValueChange,
  onAdd,
  filterKey
}) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && value?.trim()) {
      event.preventDefault();
      onAdd(value);
    }
  };

  const handlePlaceSelect = (place: google.maps.places.AutocompletePrediction | null) => {
    if (!place?.description) return;
    onAdd(place.description);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 2 }}>
      {filterKey === 'location' ? (
        <GooglePlacesAutocomplete
          value={value}
          placeholder={placeholder}
          onValueChange={onValueChange}
          onKeyDown={handleKeyDown}
          onPlaceSelect={handlePlaceSelect}
        />
      ) : (
        <Autocomplete
          size="small"
          freeSolo
          options={options}
          value={value}
          onChange={(_, newValue) => {
            if (newValue) {
              onAdd(newValue);
            }
          }}
          onInputChange={(_, newInputValue) => {
            onValueChange(newInputValue);
          }}
          onKeyDown={handleKeyDown}
          renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
          sx={{ flex: 1 }}
        />
      )}
      <Button
        variant="outlined"
        size="small"
        onClick={() => onAdd(value)}
        disabled={!value?.trim()}
        sx={{
          padding: theme.spacing(1)
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

export default FilterInput;
